export const button = () => ({
    height: 20,
});
